const emailData = [
    {
        id: 1,
        unread: true,
        text: 'warning',
        title: 'NATOLA Aleksandra Kemnitz',
        subject: 'Bardzo proszę o kontakt telefoniczny w celu ustalenia terminu wizytacji.',
        date: '10-Jan'
    },
    {
        id: 2,
        title: 'Natalia Górnaiak (NATOLA)',
        subject: 'Ekspozycje na 2023-03 Ważne!!!',
        date: '01-Feb'
    },
    {
        id: 3,
        title: 'Robert Mika',
        subject: 'Wita, proszę wszytskich o wykonanie bieżacych zadań w terminie do 28.04.2023 r.',
        date: '28-Apr'
    }, {
        id: 4,
        text: 'warning',
        title: 'Marek Siuda',
        subject: 'Aktualizacja Bloz - prosze nie wyłączać komputerów dnia 28.04.2023 r.',
        date: '08-Jan'
    },  ];


export { emailData };

